import * as React from "react"

export default function CalendarLoading() {
    return <div className="loadingCalendar">
        <div className="actions"></div><div className="title"></div>
        <div className="calendar"></div>
    </div>
}